import * as React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  Input,
} from '@fluentui/react-components';

interface RenameChatDialogProps {
  open: boolean;
  title: string;
  initialValue: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
}

const RenameChatDialog: React.FC<RenameChatDialogProps> = ({
  open,
  title,
  initialValue,
  confirmText = 'Save',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = React.useState(initialValue || '');
  React.useEffect(() => setValue(initialValue || ''), [initialValue, open]);

  const handleSubmit = () => {
    const v = value.trim();
    if (!v) return;
    onConfirm(v);
  };

  return (
    <Dialog open={open} modalType="modal" onOpenChange={(_, d) => { if (!d.open) onCancel(); }}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Input value={value} onChange={(_, data) => setValue(data.value)} style={{ width: '100%' }} />
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel}>
              {cancelText}
            </Button>
            <Button appearance="primary" onClick={handleSubmit}>
              {confirmText}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default RenameChatDialog;
